module.exports = __webpack_public_path__ + "img/night.58517f5a.png";